/**
 * ReportsHarvestInspectionCosmeticDefectPercentage
 */
import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Selectors
import { makeSelectReportsHarvestInspectionValue } from '../../services/reportsHarvestInspections/selectors';

interface Props {
    cosmeticDefectPercentage?: ?number;
}

export class ReportsHarvestInspectionCosmeticDefectPercentage extends React.PureComponent<Props> {
    render() {
        const { cosmeticDefectPercentage } = this.props;
        if (!cosmeticDefectPercentage && cosmeticDefectPercentage !== 0) {
            return null;
        }
        return `${cosmeticDefectPercentage}%`;
    }
}

const mapStateToProps = createStructuredSelector({
    cosmeticDefectPercentage: makeSelectReportsHarvestInspectionValue(
        'cosmeticDefectPercentage'
    )
});

export default connect(mapStateToProps)(
    ReportsHarvestInspectionCosmeticDefectPercentage
);
